import React from 'react';
import { BellFilled, StarFilled, StarOutlined } from '@ant-design/icons';

export type StarBadgeKind = 'star' | 'bell' | 'untracked';

const BADGE_CLASS: Record<StarBadgeKind, string> = {
	star: 'border-calendulaGold-5 bg-calendulaGold-5',
	bell: 'border-calendulaGold-8 bg-calendulaGold-8',
	untracked: 'border-grey-5 bg-white',
};

// 'sm' leads a notes-log line; 'md' leads a star toast.
const SIZE_CLASS = {
	sm: { badge: 'mr-2 h-5 w-5', icon: 'text-[11px]' },
	md: {
		badge: 'work-order-starred-feedback-toast__badge h-[30px] w-[30px]',
		icon: 'block leading-none',
	},
};

/** The round gold star / bell (or grey outline star once untracked) for a star change. */
export const StarBadge: React.FC<{ badge: StarBadgeKind; size: 'sm' | 'md' }> = ({
	badge,
	size,
}) => {
	const Icon: any = badge === 'bell' ? BellFilled : badge === 'star' ? StarFilled : StarOutlined;
	return (
		<span
			className={`${SIZE_CLASS[size].badge} box-border inline-flex shrink-0 items-center justify-center rounded-full border border-solid ${BADGE_CLASS[badge]}`}
		>
			<Icon
				className={`${SIZE_CLASS[size].icon} ${
					badge === 'untracked' ? '!text-character-title-85' : '!text-white'
				}`}
			/>
		</span>
	);
};
